import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewAuthorDisplayType', {
  NONE: 10,
  AUTHOR_TYPE: 20,
  USER_GRADE: 30
});
